// Menu Toggler

export function menuToggler() {

  document.querySelectorAll('.hamburger').forEach(
    hamburger => hamburger.addEventListener('click', () => {
      document.body.classList.toggle('mobile-menu-open');
    })
  )

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.body.classList.remove('mobile-menu-open');
    }
  });

  document.querySelectorAll('.nav-container').forEach(
    container => container.addEventListener('click', (event) => {
      if (!event.target.closest('.main-nav-wrapper')) {
        document.body.classList.remove('mobile-menu-open');
      }
    })
  )
}

// Fix 100vh Problem on Mobile browsers
export function mobileViewHeightFix () {
  const element = document.querySelector('.full-screen-height')

  if (element) {
    const viewportHeight = element.getBoundingClientRect().height
    element.style.height = viewportHeight + 'px'
  }
}

export function onLoadOrResize() {
  const winWidth = window.innerWidth
  if ( winWidth >= 1024 && document.body.classList.contains('mobile-menu-open') ) {
    document.body.classList.remove('mobile-menu-open');
  }
}

export function teaserHoverImage() {
  const teasers = document.querySelectorAll('.teaser');

  // Store global mouse position
  let mouseX = 0;
  let mouseY = 0;
  let activeTeaser = null;
  let activeImage = null;

  // Track global mouse position
  document.addEventListener('mousemove', (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  // Update position on scroll
  window.addEventListener('scroll', () => {
    if (activeTeaser && activeImage) {
      updateImagePosition(activeTeaser, activeImage);
    }
  }, { passive: true });

  function updateImagePosition(teaser, hoverImage) {
    const rect = teaser.getBoundingClientRect();
    const x = mouseX - rect.left;
    const y = mouseY - rect.top;

    hoverImage.style.left = `${x}px`;
    hoverImage.style.top = `${y}px`;
  }

  teasers.forEach(teaser => {
    const hoverImage = teaser.querySelector('.teaser-hover-image');
    if (!hoverImage) return;

    teaser.addEventListener('mouseenter', () => {
      activeTeaser = teaser;
      activeImage = hoverImage;
      hoverImage.classList.add('is-visible');
    });

    teaser.addEventListener('mouseleave', () => {
      activeTeaser = null;
      activeImage = null;
      hoverImage.classList.remove('is-visible');
    });

    teaser.addEventListener('mousemove', () => {
      updateImagePosition(teaser, hoverImage);
    });
  });
}


export function onScroll() {
  if (document.body.classList.contains('home')) {
    const pageHeaderHeight = document.querySelector('.page-header').offsetHeight;
    const pageHeroHeight = document.querySelector('.hero-content').offsetHeight;
    const scrollThreshold = pageHeroHeight - pageHeaderHeight + 60;

    if (window.scrollY >= scrollThreshold) {
      document.body.classList.add('scrolled');
    } else {
      document.body.classList.remove('scrolled');
    }
  }
}

const shareButtons = () => {
  document.querySelectorAll('[data-share]').forEach(button => button.addEventListener('click', async () => {
    const title = button.getAttribute('data-title') || document.title;
    const url = button.getAttribute('data-url') || window.location.href;
    const text = button.getAttribute('data-text') || '';

    try {
      await navigator.share({
        title,
        url,
        text
      });
      console.log('Content shared successfully');
    } catch (err) {
      console.error("Error sharing:", err);
    }
  }))
}

export function startupTheme() {
  document.body.style.setProperty(
    '--scrollBarWidth',
    `${window.innerWidth - document.documentElement.clientWidth}px`
  );

  document.addEventListener("DOMContentLoaded", () => {
    menuToggler()
    mobileViewHeightFix()
    teaserHoverImage()
    shareButtons()

    window.addEventListener('load', onLoadOrResize)
    window.addEventListener('resize', onLoadOrResize)
    window.addEventListener('scroll', onScroll)
  });
}

console.log(`%c
       ___                         ___           ___           ___
      /  /\\                       /__/\\         /__/\\         /  /\\
     /  /:/_                      \\  \\:\\        \\  \\:\\       /  /::|
    /  /:/ /\\    ___     ___       \\  \\:\\        \\  \\:\\     /  /:/\:|
   /  /:/_/::\\  /__/\\   /  /\\  ___  \\  \\:\\   _____\\__\\:\\   /  /:/|:|__
  /__/:/__\\/\\:\\ \\  \\:\\ /  /:/ /__/\\  \\__\\:\\ /__/::::::::\\ /__/:/ |:| /\\
  \\  \\:\\ /~~/:/  \\  \\:\\  /:/  \\  \\:\\ /  /:/ \\  \\:\\~~\\~~\\/ \\__\\/  |:|/:/
   \\  \\:\\  /:/    \\  \\:\\/:/    \\  \\:\\  /:/   \\  \\:\\  ~~~      |  |:/:/
    \\  \\:\\/:/      \\  \\::/      \\  \\:\\/:/     \\  \\:\\          |  |::/
     \\  \\::/        \\__\\/        \\  \\::/       \\  \\:\\         |  |:/
      \\__\\/                       \\__\\/         \\__\\/         |__|/

 www.glunz.ch
 `, `font-family: monospace`);
